// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   AppSidebar.css — Sidebar commune QLIO Manager
   Utilisée par tous les modules de l'application
   ============================================================ */

.app-sidebar {
    width: 240px;
    min-width: 240px;
    background: #0f172a;
    color: white;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 0;
    height: 100vh;
    overflow: hidden;
    box-shadow: 3px 0 16px rgba(0,0,0,0.25);
    z-index: 200;
    transition: width 0.22s ease, min-width 0.22s ease;
    flex-shrink: 0;
}

.app-sidebar-collapsed {
    width: 56px;
    min-width: 56px;
}

/* ---- Bouton collapse ---- */
.app-sb-toggle {
    position: absolute;
    right: -12px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #e2e8f0;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 300;
    font-size: 9px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.18);
    transition: all 0.15s;
    padding: 0;
    line-height: 1;
}

.app-sb-toggle:hover {
    background: #f1f5f9;
    color: #334155;
    box-shadow: 0 3px 10px rgba(0,0,0,0.22);
}

/* ---- Logo ---- */
.app-sb-logo {
    padding: 16px 14px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    min-height: 64px;
    overflow: hidden;
    white-space: nowrap;
}

.app-sidebar-collapsed .app-sb-logo {
    justify-content: center;
    padding: 14px 0;
}

.app-sb-logo-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
    color: white;
}

.app-sb-logo-name { font-size: 15px; font-weight: 800; color: #fff; letter-spacing: 0.3px; }
.app-sb-logo-sub  { font-size: 9px; color: rgba(255,255,255,0.4); letter-spacing: 0.5px; text-transform: uppercase; margin-top: 1px; }

/* ---- Formation active ---- */
.app-sb-formation {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    background: rgba(0,0,0,0.12);
    flex-shrink: 0;
}

.app-sb-formation label {
    font-size: 9px;
    font-weight: 700;
    color: rgba(255,255,255,0.35);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    display: block;
    margin-bottom: 4px;
}

.app-sb-formation select {
    width: 100%;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.15);
    color: #fff;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    padding: 6px 8px;
    font-family: inherit;
    cursor: pointer;
    outline: none;
}

.app-sb-formation select option { background: #0f172a; color: white; }

/* Mode réduit — année abrégée */
.app-sb-formation-mini {
    padding: 6px 0;
    text-align: center;
    font-size: 10px;
    font-weight: 700;
    color: rgba(255,255,255,0.5);
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    background: rgba(0,0,0,0.12);
    flex-shrink: 0;
}

/* ---- Navigation ---- */
.app-sb-nav {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 6px 0 4px;
}

.app-sb-nav::-webkit-scrollbar { width: 3px; }
.app-sb-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 3px; }

.app-nav-cat {
    font-size: 9px;
    font-weight: 700;
    color: rgba(255,255,255,0.28);
    letter-spacing: 1.2px;
    text-transform: uppercase;
    padding: 10px 16px 4px;
    white-space: nowrap;
}

.app-nav-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 9px 16px;
    cursor: pointer;
    color: rgba(255,255,255,0.65);
    font-size: 12.5px;
    font-weight: 500;
    transition: all 0.12s;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    user-select: none;
    border-left: 3px solid transparent;
}

.app-nav-item:hover:not(.app-nav-disabled) {
    background: rgba(255,255,255,0.07);
    color: #fff;
}

.app-nav-item.app-nav-active {
    background: rgba(255,255,255,0.10);
    color: #fff;
    /* border-left-color défini via inline style (couleur du module) */
}

.app-nav-item.app-nav-disabled { opacity: 0.38; cursor: not-allowed; }
.app-nav-item i { width: 17px; text-align: center; font-size: 13px; flex-shrink: 0; }
.app-nav-label { flex: 1 1; }

/* Mode réduit */
.app-sidebar-collapsed .app-nav-item {
    justify-content: center;
    padding: 10px 0;
    border-left: none;
}
.app-sidebar-collapsed .app-nav-item i { width: auto; font-size: 15px; }

/* ---- Badges ---- */
.app-nav-badge {
    margin-left: auto;
    font-size: 9px;
    font-weight: 800;
    padding: 2px 6px;
    border-radius: 9px;
    min-width: 18px;
    text-align: center;
    flex-shrink: 0;
    color: #fff;
}

.app-badge-gray { background: rgba(255,255,255,0.15); color: rgba(255,255,255,0.6); }
.app-badge-dev  { background: rgba(255,255,255,0.12); color: rgba(255,255,255,0.5); font-size: 8px; letter-spacing: 0.3px; }

/* ---- Utilisateur ---- */
.app-sb-user {
    padding: 12px 14px;
    border-top: 1px solid rgba(255,255,255,0.08);
    display: flex;
    align-items: center;
    gap: 9px;
    cursor: pointer;
    transition: background 0.12s;
    flex-shrink: 0;
    overflow: hidden;
}

.app-sb-user:hover { background: rgba(255,255,255,0.05); }

.app-sidebar-collapsed .app-sb-user {
    justify-content: center;
    padding: 12px 0;
}

.app-sb-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 800;
    color: #fff;
    flex-shrink: 0;
}

.app-sb-user-name  { font-size: 12px; font-weight: 600; color: #fff; line-height: 1.3; }
.app-sb-user-role  { font-size: 10px; color: rgba(255,255,255,0.4); }
.app-sb-user-chevron { margin-left: auto; color: rgba(255,255,255,0.3); font-size: 11px; }

.app-sb-copyright {
    padding: 6px 16px;
    font-size: 9px;
    color: rgba(255,255,255,0.2);
    text-align: center;
    letter-spacing: 0.3px;
    border-top: 1px solid rgba(255,255,255,0.06);
}
`, "",{"version":3,"sources":["webpack://./src/components/AppSidebar.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,gBAAgB;IAChB,uCAAuC;IACvC,YAAY;IACZ,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,sCAAsC;IACtC,qBAAqB;IACrB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,uCAAuC;AAC3C;;AAEA,mBAAmB;AACnB;IACI,uBAAuB;IACvB,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC3F,oBAAoB,cAAc,EAAE,4BAA4B,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,eAAe,EAAE;;AAErI,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,wCAAwC;IACxC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,aAAa;AACjB;;AAEA,kCAAkC,mBAAmB,EAAE,YAAY,EAAE;;AAErE,gCAAgC;AAChC;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;IACrB,+CAA+C;IAC/C,4BAA4B;IAC5B,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,iCAAiC,UAAU,EAAE;AAC7C,uCAAuC,kCAAkC,EAAE,kBAAkB,EAAE;;AAE/F;IACI,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,kEAAkE;AACtE;;AAEA,iCAAiC,aAAa,EAAE,mBAAmB,EAAE;AACrE,kBAAkB,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE;AACpF,iBAAiB,SAAO,EAAE;;AAE1B,gBAAgB;AAChB;IACI,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;AACA,yCAAyC,WAAW,EAAE,eAAe,EAAE;;AAEvE,qBAAqB;AACrB;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA,kBAAkB,kCAAkC,EAAE,4BAA4B,EAAE;AACpF,kBAAkB,kCAAkC,EAAE,4BAA4B,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAE3H,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;AACpB;;AAEA,qBAAqB,kCAAkC,EAAE;;AAEzD;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACvF,qBAAqB,eAAe,EAAE,4BAA4B,EAAE;AACpE,uBAAuB,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAEzF;IACI,iBAAiB;IACjB,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;IAClB,qBAAqB;IACrB,4CAA4C;AAChD","sourcesContent":["/* ============================================================\n   AppSidebar.css — Sidebar commune QLIO Manager\n   Utilisée par tous les modules de l'application\n   ============================================================ */\n\n.app-sidebar {\n    width: 240px;\n    min-width: 240px;\n    background: #0f172a;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    position: sticky;\n    top: 0;\n    height: 100vh;\n    overflow: hidden;\n    box-shadow: 3px 0 16px rgba(0,0,0,0.25);\n    z-index: 200;\n    transition: width 0.22s ease, min-width 0.22s ease;\n    flex-shrink: 0;\n}\n\n.app-sidebar-collapsed {\n    width: 56px;\n    min-width: 56px;\n}\n\n/* ---- Bouton collapse ---- */\n.app-sb-toggle {\n    position: absolute;\n    right: -12px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: #fff;\n    border: 2px solid #e2e8f0;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 300;\n    font-size: 9px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.18);\n    transition: all 0.15s;\n    padding: 0;\n    line-height: 1;\n}\n\n.app-sb-toggle:hover {\n    background: #f1f5f9;\n    color: #334155;\n    box-shadow: 0 3px 10px rgba(0,0,0,0.22);\n}\n\n/* ---- Logo ---- */\n.app-sb-logo {\n    padding: 16px 14px 12px;\n    border-bottom: 1px solid rgba(255,255,255,0.08);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n    min-height: 64px;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.app-sidebar-collapsed .app-sb-logo {\n    justify-content: center;\n    padding: 14px 0;\n}\n\n.app-sb-logo-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    flex-shrink: 0;\n    color: white;\n}\n\n.app-sb-logo-name { font-size: 15px; font-weight: 800; color: #fff; letter-spacing: 0.3px; }\n.app-sb-logo-sub  { font-size: 9px; color: rgba(255,255,255,0.4); letter-spacing: 0.5px; text-transform: uppercase; margin-top: 1px; }\n\n/* ---- Formation active ---- */\n.app-sb-formation {\n    padding: 10px 12px;\n    border-bottom: 1px solid rgba(255,255,255,0.07);\n    background: rgba(0,0,0,0.12);\n    flex-shrink: 0;\n}\n\n.app-sb-formation label {\n    font-size: 9px;\n    font-weight: 700;\n    color: rgba(255,255,255,0.35);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    display: block;\n    margin-bottom: 4px;\n}\n\n.app-sb-formation select {\n    width: 100%;\n    background: rgba(255,255,255,0.1);\n    border: 1px solid rgba(255,255,255,0.15);\n    color: #fff;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 6px 8px;\n    font-family: inherit;\n    cursor: pointer;\n    outline: none;\n}\n\n.app-sb-formation select option { background: #0f172a; color: white; }\n\n/* Mode réduit — année abrégée */\n.app-sb-formation-mini {\n    padding: 6px 0;\n    text-align: center;\n    font-size: 10px;\n    font-weight: 700;\n    color: rgba(255,255,255,0.5);\n    letter-spacing: 0.5px;\n    border-bottom: 1px solid rgba(255,255,255,0.07);\n    background: rgba(0,0,0,0.12);\n    flex-shrink: 0;\n}\n\n/* ---- Navigation ---- */\n.app-sb-nav {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 6px 0 4px;\n}\n\n.app-sb-nav::-webkit-scrollbar { width: 3px; }\n.app-sb-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 3px; }\n\n.app-nav-cat {\n    font-size: 9px;\n    font-weight: 700;\n    color: rgba(255,255,255,0.28);\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    padding: 10px 16px 4px;\n    white-space: nowrap;\n}\n\n.app-nav-item {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    padding: 9px 16px;\n    cursor: pointer;\n    color: rgba(255,255,255,0.65);\n    font-size: 12.5px;\n    font-weight: 500;\n    transition: all 0.12s;\n    position: relative;\n    white-space: nowrap;\n    overflow: hidden;\n    user-select: none;\n    border-left: 3px solid transparent;\n}\n\n.app-nav-item:hover:not(.app-nav-disabled) {\n    background: rgba(255,255,255,0.07);\n    color: #fff;\n}\n\n.app-nav-item.app-nav-active {\n    background: rgba(255,255,255,0.10);\n    color: #fff;\n    /* border-left-color défini via inline style (couleur du module) */\n}\n\n.app-nav-item.app-nav-disabled { opacity: 0.38; cursor: not-allowed; }\n.app-nav-item i { width: 17px; text-align: center; font-size: 13px; flex-shrink: 0; }\n.app-nav-label { flex: 1; }\n\n/* Mode réduit */\n.app-sidebar-collapsed .app-nav-item {\n    justify-content: center;\n    padding: 10px 0;\n    border-left: none;\n}\n.app-sidebar-collapsed .app-nav-item i { width: auto; font-size: 15px; }\n\n/* ---- Badges ---- */\n.app-nav-badge {\n    margin-left: auto;\n    font-size: 9px;\n    font-weight: 800;\n    padding: 2px 6px;\n    border-radius: 9px;\n    min-width: 18px;\n    text-align: center;\n    flex-shrink: 0;\n    color: #fff;\n}\n\n.app-badge-gray { background: rgba(255,255,255,0.15); color: rgba(255,255,255,0.6); }\n.app-badge-dev  { background: rgba(255,255,255,0.12); color: rgba(255,255,255,0.5); font-size: 8px; letter-spacing: 0.3px; }\n\n/* ---- Utilisateur ---- */\n.app-sb-user {\n    padding: 12px 14px;\n    border-top: 1px solid rgba(255,255,255,0.08);\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    cursor: pointer;\n    transition: background 0.12s;\n    flex-shrink: 0;\n    overflow: hidden;\n}\n\n.app-sb-user:hover { background: rgba(255,255,255,0.05); }\n\n.app-sidebar-collapsed .app-sb-user {\n    justify-content: center;\n    padding: 12px 0;\n}\n\n.app-sb-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 800;\n    color: #fff;\n    flex-shrink: 0;\n}\n\n.app-sb-user-name  { font-size: 12px; font-weight: 600; color: #fff; line-height: 1.3; }\n.app-sb-user-role  { font-size: 10px; color: rgba(255,255,255,0.4); }\n.app-sb-user-chevron { margin-left: auto; color: rgba(255,255,255,0.3); font-size: 11px; }\n\n.app-sb-copyright {\n    padding: 6px 16px;\n    font-size: 9px;\n    color: rgba(255,255,255,0.2);\n    text-align: center;\n    letter-spacing: 0.3px;\n    border-top: 1px solid rgba(255,255,255,0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
